export default __webpack_public_path__ + "static/media/declarations-icon.ec23b573.svg";